import {Fragment} from "preact";
import s from "./fullPageLoaderV2.module.css";
import {iconLoader} from "../../../assets";
import {useAppContext} from "../../../contexts";

const FullPageLoaderV2 = () => {
    // Destructures the state that will control the loader display state
    const {fullPageLoaderV2} = useAppContext();

    return fullPageLoaderV2 ? (
        <Fragment>
            <div className={`fixed inset-0 w-screen h-screen z-50 ${s.root}`}>
                <div className="relative h-full w-full z-0">
                    <div className={`p-14 bg-white border border-black rounded-3xl ${s.loader}`}>
                        <img
                            src={iconLoader}
                            className={`dark:grayscale`}
                            alt={"Loader icon"}
                        />
                    </div>
                    <div className={s.backdrop} />
                </div>
            </div>
        </Fragment>
    ) : null;
}

export default FullPageLoaderV2;
